export default __webpack_public_path__ + "static/media/Analysispinguin.6a8104d6.png";